import { createContext } from "react";
import { Node } from "reactflow";

export class HomeContextParams {
  constructor(public showAllInputs: (saasInputNodeIds: string[], saasNodes: Node[], index?: number) => void) {}
}
export const HomeUsePluginContext = createContext<HomeContextParams | undefined>(undefined);
